import * as React from "react";

export const Music = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8516 1.0274C13.9336 1 14.0156 1 14.125 1C14.5898 1 14.9727 1.38356 15 1.84932V11.4932C15 12.4795 13.8242 13.2466 12.375 13.2466C10.9258 13.2466 9.75 12.4795 9.75 11.4932C9.75 10.5342 10.9258 9.73973 12.375 9.73973C12.6758 9.76712 12.9492 9.79452 13.25 9.84931V4.80822L6.25 6.86301V13.2466C6.25 14.2329 5.07422 15 3.625 15C2.17578 15 1 14.2329 1 13.2466C1 12.2877 2.17578 11.4932 3.625 11.4932C3.92578 11.5205 4.19922 11.5479 4.5 11.6027V4.45205C4.5 4.06849 4.74609 3.73973 5.10156 3.60274L13.8516 1.0274Z"
    />
);
